import { gql } from "@apollo/client";

export const PRODUCT_YEAR_QUERY = gql`
  query GetProductYearData($productLevel: Int!, $productClass: ProductClass!) {
    productYear(productLevel: $productLevel, productClass: $productClass) {
      productId
      productLevel
      year
      exportValue
      importValue
      exportValueGrowth5: exportValueConstGrowth5
      importValueGrowth5: importValueConstGrowth5
      exportValueCagr5: exportValueConstCagr5
      importValueCagr5: importValueConstCagr5
      pci
      complexityEnum
    }
  }
`;

export const PRODUCT_META_HS12 = gql`
  query GetHS12ProductMetadata {
    fourDigit: productHs12(productLevel: 4) {
      productId
      productLevel
      code
      nameEn
      nameShortEn
      isShown
      parent { productId productLevel }
      topParent { productId productLevel }
    }
  }
`;
